<app-form-wrapper title="Campaign details">
  <form [formGroup]="campaignDetailForm" (ngSubmit)="handleSubmit()" novalidate>
    <div class="cf__body">
      <!-- Campaign name -->
      <input-field
        label="Campaign name"
        hint="Only your team sees this."
        [errorMessage]="submitted && campaignName?.invalid ? 'Enter a name for the campaign.' : ''"
      >
        <input
          type="text"
          name="cName"
          id="cName"
          class="input-style"
          placeholder="For example, October fee reminders"
          autocomplete="off"
          formControlName="campaignName"
          (change)="campaignDetailsService.campaignDetails.campaignName = campaignName!.value"
        />
      </input-field>

      <!-- Description -->
      <input-field
        label="Description"
        [errorMessage]="submitted && description?.invalid ? 'Describe what the campaign is for.' : ''"
      >
        <textarea
          name="description"
          id="description"
          rows="3"
          class="input-style"
          placeholder="Who it is for and why it is going out"
          formControlName="description"
          (change)="campaignDetailsService.campaignDetails.description = description!.value"
        ></textarea>
      </input-field>

      <!-- Goals -->
      <p class="cf__section-label" id="cf-goals-label">Goals</p>
      <div class="cf__goals" formArrayName="goals" role="group" aria-labelledby="cf-goals-label">
        @for (goal of goals.controls; track goal) {
          <div class="cf__item">
            <input-field
              [label]="$count > 1 ? 'Goal ' + ($index + 1) : 'Goal'"
              [errorMessage]="submitted && goal.invalid ? 'Write the goal, or remove it.' : ''"
            >
              <textarea
                [name]="'goal-' + $index"
                [id]="'goal-' + $index"
                rows="2"
                class="input-style"
                placeholder="For example, 80% of parents pay before the 15th"
                [formControlName]="$index"
                (change)="campaignDetailsService.getGoal(goal.value, $index)"
              ></textarea>
            </input-field>

            @if ($count > 1) {
              <button
                type="button"
                class="bk-icon-btn cf__remove"
                [attr.aria-label]="'Remove goal ' + ($index + 1)"
                matTooltip="Remove goal"
                (click)="removeGoal($index)"
              >
                <span class="bk-sym" aria-hidden="true">close</span>
              </button>
            }
          </div>
        }
      </div>

      <button type="button" class="cf__add" (click)="addGoal()">
        <span class="bk-sym" aria-hidden="true">add</span>
        {{ goals.length > 0 ? "Add another goal" : "Add a goal" }}
      </button>
    </div>

    <!-- footer -->
    <div class="cf__foot">
      <button type="button" class="bk-btn bk-btn--ghost" (click)="this.cancelCampaignService.openCancelModal()">
        Cancel
      </button>
      <div class="cf__foot-end">
        <button type="submit" class="bk-btn bk-btn--primary">
          Continue to recipients
          <span class="bk-sym cf__go" aria-hidden="true">arrow_forward</span>
        </button>
      </div>
    </div>
  </form>
</app-form-wrapper>
